<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :data="tableData"
      :row-class-name="rowClassName"
      :columns="tableColumns"
      :loading="loading"
      :height="160"
      size="mini"
      resizable
      border
    >
    </vxe-grid>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    loading: {
      default: false
    }
  },

  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        }
      },
      rowClassName: ({ row }) => {
        if (!row.weightBoolean) {
          return 'bg-danger text-white'
        }
        return ''
      },
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq'
        },
        {
          field: 'dispatchOrderNo',
          title: '调度订单编号',
          headerAlign: 'center',
          align: 'center',
          fixed: 'left',
          width: 170,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'bizBillNo',
          title: 'ERP/WMS单号',
          headerAlign: 'center',
          align: 'center',
          fixed: 'left',
          width: 150,
          showHeaderOverflow: 'title',
          showOverflow: true
        },
        {
          field: 'wmsWayBillNo',
          title: '客户订单号',
          fixed: 'left',
          headerAlign: 'center',
          align: 'center',
          width: 150,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'orderSoNo',
          title: 'SO订单号',
          fixed: 'left',
          headerAlign: 'center',
          align: 'center',
          width: 150,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'custShortName',
          title: '客户',
          headerAlign: 'center',
          align: 'left',
          width: 140,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'orderTypeName',
          title: '订单类型',
          headerAlign: 'center',
          align: 'center',
          width: 80,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'bizTypeName',
          title: '业务类型',
          headerAlign: 'center',
          align: 'center',
          width: 80,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'transportModeName',
          title: '运输模式',
          headerAlign: 'center',
          align: 'center',
          width: 80,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'orgName',
          title: '组织机构',
          headerAlign: 'center',
          align: 'left',
          width: 180,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'pickupPointName',
          title: '发货方',
          headerAlign: 'center',
          align: 'left',
          width: 120,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'pickupProvinceName',
          title: '发货省份',
          headerAlign: 'center',
          align: 'left',
          width: 100,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'pickupCityName',
          title: '发货城市',
          headerAlign: 'center',
          align: 'left',
          width: 100,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'pickupDistrictName',
          title: '发货区县',
          headerAlign: 'center',
          align: 'left',
          width: 100,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'pickupAddress',
          title: '发货地址',
          headerAlign: 'center',
          align: 'left',
          width: 180,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'pickupContactName',
          title: '发货联系人',
          headerAlign: 'center',
          align: 'left',
          width: 100,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'pickupContactMobile',
          title: '发货手机号',
          headerAlign: 'center',
          align: 'center',
          width: 110,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'receivePointName',
          title: '收货方',
          headerAlign: 'center',
          align: 'left',
          width: 120,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'receiveProvinceName',
          title: '收货省份',
          headerAlign: 'center',
          align: 'left',
          width: 100,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'receiveCityName',
          title: '收货城市',
          headerAlign: 'center',
          align: 'left',
          width: 100,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'receiveDistrictName',
          title: '收货区县',
          headerAlign: 'center',
          align: 'left',
          width: 100,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'receiveAddress',
          title: '收货地址',
          headerAlign: 'center',
          align: 'left',
          width: 150,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'receiveContactName',
          title: '收货联系人',
          headerAlign: 'center',
          align: 'left',
          width: 100,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          field: 'receiveContactMobile',
          title: '收货手机号',
          headerAlign: 'center',
          align: 'center',
          width: 110,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        }
      ]
    }
  },
  methods: {}
}
</script>
